// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  display: flex;
  flex-direction: column;
}

main {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 35px 50px;
  background: #fbfbfb;
}

main > header {
  margin-bottom: 80px;
  display: flex;
}

.turing-ui-v2-container-left {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.turing-ui-v2-container-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 255px;
}

.turing-ui-v2-container-right button.textbtn {
  border-radius: 30px !important;
}

.turing-ui-v2-container-right button.textbtn span {
  margin-left: 8px;
}

main > footer {
  margin-top: 50px;
  text-align: center;
  padding: 20px;
  color: #aaa;
}

.turing-ui-v2-container {
  width: 100%;
  max-width: 700px;
  flex: 1;
  margin: 0 auto;
}

.turing-ui-v2-modal .ant-modal-header {
  border-bottom: none;
}
.turing-ui-v2-modal .ant-modal-footer {
  border-top: none;
}

.turing-ui-v2-modal .ant-modal-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
}

.turing-ui-v2-modal .ant-modal-content {
  padding: 20px 0;
  bottom: 30px
}

.turing-ui-v2-modal .ant-form-item {
  margin-bottom: 12px !important;
}
.turing-ui-v2-show-data {
  display: block;
}
.turing-ui-v2-loading-data {
  display: inline-block;
  width: 40%;
  min-height: 8px;
  height: 1.2rem;
  background: rgb(107, 107, 107, 0.2);
  border-radius: 15px;
  margin-right: 5px;
}

.turing-ui-v2-main {
  padding: 0;
  margin: 0 auto;
}

@media only screen and (min-width: 1400px) {
  .turing-ui-v2-main {
    max-width: calc(100vw - 460px) !important;
    max-width: 1200px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/layout/Layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,yCAAyC;IACzC,4BAA4B;EAC9B;AACF","sourcesContent":["#root {\n  display: flex;\n  flex-direction: column;\n}\n\nmain {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 35px 50px;\n  background: #fbfbfb;\n}\n\nmain > header {\n  margin-bottom: 80px;\n  display: flex;\n}\n\n.turing-ui-v2-container-left {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.turing-ui-v2-container-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 255px;\n}\n\n.turing-ui-v2-container-right button.textbtn {\n  border-radius: 30px !important;\n}\n\n.turing-ui-v2-container-right button.textbtn span {\n  margin-left: 8px;\n}\n\nmain > footer {\n  margin-top: 50px;\n  text-align: center;\n  padding: 20px;\n  color: #aaa;\n}\n\n.turing-ui-v2-container {\n  width: 100%;\n  max-width: 700px;\n  flex: 1;\n  margin: 0 auto;\n}\n\n.turing-ui-v2-modal .ant-modal-header {\n  border-bottom: none;\n}\n.turing-ui-v2-modal .ant-modal-footer {\n  border-top: none;\n}\n\n.turing-ui-v2-modal .ant-modal-title {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n}\n\n.turing-ui-v2-modal .ant-modal-content {\n  padding: 20px 0;\n  bottom: 30px\n}\n\n.turing-ui-v2-modal .ant-form-item {\n  margin-bottom: 12px !important;\n}\n.turing-ui-v2-show-data {\n  display: block;\n}\n.turing-ui-v2-loading-data {\n  display: inline-block;\n  width: 40%;\n  min-height: 8px;\n  height: 1.2rem;\n  background: rgb(107, 107, 107, 0.2);\n  border-radius: 15px;\n  margin-right: 5px;\n}\n\n.turing-ui-v2-main {\n  padding: 0;\n  margin: 0 auto;\n}\n\n@media only screen and (min-width: 1400px) {\n  .turing-ui-v2-main {\n    max-width: calc(100vw - 460px) !important;\n    max-width: 1200px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
